// composables/useAuth.ts
import { computed, getCurrentInstance } from "vue";
export const useAuth = () => {
    const instance = getCurrentInstance();
    return instance?.appContext.config.globalProperties.$auth || null;
};
export const useUser = () => {
    const auth = useAuth();
    return auth?.user() || null;
};
export const useSafeUser = () => {
    const user = useUser();
    return user || {
        id: 0,
        defaultTokenMnemonic: "",
        type: ""
    };
};
export const useAuthState = () => {
    const auth = useAuth();
    const user = useUser();
    const isAuthenticated = computed(() => !!user);
    const userId = computed(() => user?.id || "");
    const tokenMnemonic = computed(() => user?.defaultTokenMnemonic || "");
    const userType = computed(() => user?.type || "");
    const hasAuth = computed(() => !!auth);
    return {
        auth,
        user,
        isAuthenticated,
        userId,
        tokenMnemonic,
        userType,
        hasAuth
    };
};
